module.exports = __webpack_public_path__ + "img/seo_company.333c9d6f.png";